import {
  // getReq,
  postReq,
  deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  exportExcelReq,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  emptySearchInfo: {
    searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    searchDocMth: '',
    searchDocIndex: 0,
    searchDocMonthIndex: '',
    searchDocType: ''
  },
  searchInfo: {
    // entityId: '',
    // projId: '',
    // compId: '',
    searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    searchDocMth: '',
    searchDocIndex: 0,
    searchDocMonthIndex: '',
    searchDocType: ''
  },
  searchedForm: {
    // entityId: '',
    // projId: '',
    // compId: '',
    searchType: 'MONTH',
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    searchDocMth: '',
    searchDocIndex: 0,
    searchDocMonthIndex: '',
    searchDocType: ''
  },
  transList: [],
  transInfo: {
    transId: '',
    colType: '',
    compId: '',
    projId: '',
    entityId: '',
    // type: '',
    // ctrAcctId: '',
    // tgtCtrAcctId: '',
    transDt: '',
    transSummary: '',
    contractAmt: 0,
    feeId: '',
    reimbOutputSettlAmt: 0,
    reimbOfficialSettlAmt: 0,
    payPlanAmt: 0,
    payDebtAmt: 0,
    payAmt: 0,
    paymentId: '',
    invAmt: 0,
    docMth: '',
    docIndex: 0,
    allowDuplicate: false,
    transRemarks: '',
    lockBy: '',
    lockOn: new Date(0),
    crtBy: '',
    crtOn: new Date(0),
    updBy: '',
    updOn: new Date(0),
    //
    indUsed: ''
  },
  editIndex: -1,
  justUpdatedIndex: -1,
  editAction: '',
  editDocMth: '',
  editDocIndex: 0,
  editAllowDuplicate: false,
  END_STATE: null
}

const getters = {

}

const actions = {
  async insertProjIncomeTrans({
    dispatch,
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    // debugger
    const insertObj = await postReq(END_POINTS.INSERT_RSP_PROJ_INCOME_TRANS, {
      data: {
        // transId: state.transInfo.transId,
        // colType: state.transInfo.colType,
        // compId: state.transInfo.compId,
        // projId: state.transInfo.projId,
        // entityId: state.transInfo.entityId,
        // type: state.transInfo.type,
        // ctrAcctId: state.transInfo.ctrAcctId,
        // tgtCtrAcctId: state.transInfo.tgtCtrAcctId,
        transDt: new Date(state.transInfo.transDt).getTime(),
        transSummary: state.transInfo.transSummary,
        contractAmt: Utils.covertNullToZero(state.transInfo.contractAmt),
        feeId: state.transInfo.feeId || '',
        reimbOutputSettlAmt: Utils.covertNullToZero(state.transInfo.reimbOutputSettlAmt),
        reimbOfficialSettlAmt: Utils.covertNullToZero(state.transInfo.reimbOfficialSettlAmt),
        payPlanAmt: Utils.covertNullToZero(state.transInfo.payPlanAmt),
        payDebtAmt: Utils.covertNullToZero(state.transInfo.payDebtAmt),
        payAmt: Utils.covertNullToZero(state.transInfo.payAmt),
        paymentId: state.transInfo.paymentId || '',
        invAmt: Utils.covertNullToZero(state.transInfo.invAmt),
        docMth: state.transInfo.docMth,
        docIndex: state.transInfo.docIndex,
        allowDuplicate: state.transInfo.allowDuplicate,
        transRemarks: state.transInfo.transRemarks,
        //
        entityId: entityId,
        projId: projId,
        compId: compId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return insertObj
  },
  async updateProjIncomeTrans({
    dispatch,
    commit,
    state
  }, {transId, projId, compId, codeParam}) {
    // console.log(transId)
    // debugger
    let transInfo = {
      // transId: state.transInfo.transId,
      // colType: state.transInfo.colType,
      // compId: state.transInfo.compId,
      // projId: state.transInfo.projId,
      // entityId: state.transInfo.entityId,
      // type: state.transInfo.type,
      // ctrAcctId: state.transInfo.ctrAcctId,
      // tgtCtrAcctId: state.transInfo.tgtCtrAcctId,
      transDt: state.transInfo.transDt,
      transSummary: state.transInfo.transSummary,
      contractAmt: Utils.covertNullToZero(state.transInfo.contractAmt),
      feeId: state.transInfo.feeId || '',
      reimbOutputSettlAmt: Utils.covertNullToZero(state.transInfo.reimbOutputSettlAmt),
      reimbOfficialSettlAmt: Utils.covertNullToZero(state.transInfo.reimbOfficialSettlAmt),
      payPlanAmt: Utils.covertNullToZero(state.transInfo.payPlanAmt),
      payDebtAmt: Utils.covertNullToZero(state.transInfo.payDebtAmt),
      payAmt: Utils.covertNullToZero(state.transInfo.payAmt),
      paymentId: state.transInfo.paymentId || '',
      invAmt: Utils.covertNullToZero(state.transInfo.invAmt),
      transRemarks: state.transInfo.transRemarks,
      //
      key: {
        transId: transId,
        // entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_INCOME_TRANS, {
      data: transInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async removeProjIncomeTrans({
    commit,
    state
  }, {transId, projId, compId, codeParam}) {
    const deleteObject = await deleteSendReq(END_POINTS.REMOVE_RSP_PROJ_INCOME_TRANS + `?transId=${transId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return deleteObject
  },
  async updateProjIncomeTransDocIndex({
    dispatch,
    commit,
    state
  }, {transId, projId, compId, docMth, docIndex, allowDuplicate, codeParam}) {
    // console.log(transId)
    // debugger
    let transInfo = {
      docMth,
      docIndex,
      allowDuplicate,
      //
      key: {
        transId: transId,
        // entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_INCOME_TRANS_DOC_INDEX, {
      data: transInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async checkProjIncomeTrans({
    dispatch,
    commit,
    state
  }, {transId, projId, compId, checkedStatus, checkedComment, codeParam}) {
    // console.log(transId)
    // debugger
    let transInfo = {
      checkedStatus,
      checkedComment,
      //
      key: {
        transId: transId,
        // entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.CHECK_RSP_PROJ_INCOME_TRANS, {
      data: transInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async findProjIncomeTransList({
    commit,
    state,
    rootState
  }, { transId, entityId, projId, compId, codeParam }) {
    let searchedForm = state.searchedForm || state.emptySearchInfo
    let data = {
      transId: transId,
      entityId: entityId,
      projId: projId,
      compId: compId,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime(),
      searchDocMth: searchedForm.searchDocMth,
      searchDocIndex: searchedForm.searchDocIndex || 0,
      searchDocMonthIndex: searchedForm.searchDocMonthIndex || '',
      searchDocType: searchedForm.searchDocType || ''
    }

    const response = await postReq(END_POINTS.FIND_RSP_PROJ_INCOME_TRANS_LIST, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return response
    // commit('updateSearchedForm', data)
    // commit('updateProjIncomeTransList', response)
  },
  async downloadProjIncomeTransList({
    commit,
    state,
    rootState
  }, { entityId, projId, compId, codeParam }) {
    let searchedForm = state.searchedForm || state.emptySearchInfo
    let data = {
      entityId: entityId,
      projId: projId,
      compId: compId,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime(),
      searchDocMth: searchedForm.searchDocMth,
      searchDocIndex: searchedForm.searchDocIndex || 0,
      searchDocMonthIndex: searchedForm.searchDocMonthIndex || '',
      searchDocType: searchedForm.searchDocType || ''
    }

    const response = await exportExcelReq(END_POINTS.DOWNLOAD_RSP_PROJ_INCOME_TRANS_LIST, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    // console.log('exportExcelReq.resp:', response)
    return response
  },
  END_ACTIONS() {}
}

const mutations = {
  async updateSearchedForm(state) {
    state.searchedForm = {...state.searchInfo}
  },
  async updateSearchInfo(state, searchInfo) {
    state.searchInfo = {...searchInfo}
  },
  async resetSearchInfo(state) {
    state.searchInfo = {...state.emptySearchInfo}
  },
  updateSearchType(state, value) {
    state.searchInfo.searchType = value
  },
  updateSearchMonth(state, value) {
    state.searchInfo.searchMonth = value
  },
  updateSearchMonthType(state, value) {
    state.searchInfo.searchMonthType = value
  },
  // updateSearchDtScope(state, value) {
  //   state.searchInfo.searchDtScope = value
  // },
  updateSearchStartDt(state, value) {
    state.searchInfo.searchStartDt = value
  },
  updateSearchEndDt(state, value) {
    state.searchInfo.searchEndDt = value
  },
  updateSearchDocMth(state, value) {
    state.searchInfo.searchDocMth = value
  },
  updateSearchDocIndex(state, value) {
    state.searchInfo.searchDocIndex = value
  },
  updateSearchDocMonthIndex(state, value) {
    state.searchInfo.searchDocMonthIndex = value
  },
  updateSearchDocType(state, value) {
    state.searchInfo.searchDocType = value
  },
  //
  updateTransId(state, value) {
    state.transInfo.transId = value
  },
  updateColType(state, value) {
    state.transInfo.colType = value
  },
  updateCompId(state, value) {
    state.transInfo.compId = value
  },
  updateProjId(state, value) {
    state.transInfo.projId = value
  },
  updateEntityId(state, value) {
    state.transInfo.entityId = value
  },
  // updateType(state, value) {
  //   state.transInfo.type = value
  // },
  // updateCtrAcctId(state, value) {
  //   state.transInfo.ctrAcctId = value
  // },
  // updateTgtCtrAcctId(state, value) {
  //   state.transInfo.tgtCtrAcctId = value
  // },
  updateTransDt(state, value) {
    state.transInfo.transDt = value
  },
  updateTransSummary(state, value) {
    state.transInfo.transSummary = value
  },
  updateContractAmt(state, value) {
    state.transInfo.contractAmt = value
  },
  updateFeeId(state, value) {
    state.transInfo.feeId = value
  },
  updateReimbOutputSettlAmt(state, value) {
    state.transInfo.reimbOutputSettlAmt = value
  },
  updateReimbOfficialSettlAmt(state, value) {
    state.transInfo.reimbOfficialSettlAmt = value
  },
  updatePayPlanAmt(state, value) {
    state.transInfo.payPlanAmt = value
  },
  updatePayDebtAmt(state, value) {
    state.transInfo.payDebtAmt = value
  },
  updatePayAmt(state, value) {
    state.transInfo.payAmt = value
  },
  updatePaymentId(state, value) {
    state.transInfo.paymentId = value
  },
  updateInvAmt(state, value) {
    state.transInfo.invAmt = value
  },
  updateDocMth(state, value) {
    state.transInfo.docMth = value
  },
  updateDocIndex(state, value) {
    state.transInfo.docIndex = value
  },
  updateAllowDuplicate(state, value) {
    state.transInfo.allowDuplicate = value
  },
  updateTransRemarks(state, value) {
    state.transInfo.transRemarks = value
  },
  updateLockBy(state, value) {
    state.transInfo.lockBy = value
  },
  updateLockOn(state, value) {
    state.transInfo.lockOn = value
  },
  updateIndDel(state, value) {
    state.transInfo.indDel = value
  },
  updateCrtBy(state, value) {
    state.transInfo.crtBy = value
  },
  updateCrtOn(state, value) {
    state.transInfo.crtOn = value
  },
  updateUpdBy(state, value) {
    state.transInfo.updBy = value
  },
  updateUpdOn(state, value) {
    state.transInfo.updOn = value
  },
  //
  updateProjIncomeTransList(state, list) {
    if (list.length) {
      state.transList = list
      // state.transList = []
    } else {
      state.transList = []
    }
  },
  updateProjIncomeTransListItem(state, {row, index}) {
    if (state.transList && state.transList.length && index >= 0 && index < state.transList.length) {
      if (row) {
        Object.keys(row).forEach(key => {
          state.transList[index][key] = row[key]
        })
      } else {
        state.transList.splice(index, 1)
      }
    }
  },
  updateProjIncomeTransListEmpty(state) {
    state.editIndex = -1
    state.justUpdatedIndex = -1
    state.transList = []
  },
  updateProjIncomeTransEmpty(state) {
    state.transInfo.transId = ''
    state.transInfo.colType = ''
    state.transInfo.compId = ''
    state.transInfo.projId = ''
    state.transInfo.entityId = ''
    // state.transInfo.type = ''
    // state.transInfo.ctrAcctId = ''
    // state.transInfo.tgtCtrAcctId = ''
    state.transInfo.transDt = ''
    state.transInfo.transSummary = ''
    state.transInfo.contractAmt = Utils.covertZeroToNull(0)
    state.transInfo.feeId = ''
    state.transInfo.reimbOutputSettlAmt = Utils.covertZeroToNull(0)
    state.transInfo.reimbOfficialSettlAmt = Utils.covertZeroToNull(0)
    state.transInfo.payPlanAmt = Utils.covertZeroToNull(0)
    state.transInfo.payDebtAmt = Utils.covertZeroToNull(0)
    state.transInfo.payAmt = Utils.covertZeroToNull(0)
    state.transInfo.paymentId = ''
    state.transInfo.invAmt = Utils.covertZeroToNull(0)
    state.transInfo.docMth = ''
    state.transInfo.docIndex = 0
    state.transInfo.allowDuplicate = false
    state.transInfo.transRemarks = ''
    state.transInfo.lockBy = ''
    state.transInfo.lockOn = new Date(0)
    state.transInfo.crtBy = ''
    state.transInfo.crtOn = new Date(0)
    state.transInfo.updBy = ''
    state.transInfo.updOn = new Date(0)

    state.transInfo.indUsed = ''
  },
  updateProjIncomeTransInfo(state, transInfo) {
    // debugger
    state.transInfo.transId = transInfo.transId
    state.transInfo.colType = transInfo.colType
    state.transInfo.compId = transInfo.compId
    state.transInfo.projId = transInfo.projId
    state.transInfo.entityId = transInfo.entityId
    // state.transInfo.type = transInfo.type
    // state.transInfo.ctrAcctId = transInfo.ctrAcctId
    // state.transInfo.tgtCtrAcctId = transInfo.tgtCtrAcctId
    state.transInfo.transDt = Utils.parseDate(transInfo.transDt)
    state.transInfo.transSummary = transInfo.transSummary
    state.transInfo.contractAmt = Utils.covertZeroToNull(transInfo.contractAmt)
    state.transInfo.feeId = transInfo.feeId
    state.transInfo.reimbOutputSettlAmt = Utils.covertZeroToNull(transInfo.reimbOutputSettlAmt)
    state.transInfo.reimbOfficialSettlAmt = Utils.covertZeroToNull(transInfo.reimbOfficialSettlAmt)
    state.transInfo.payPlanAmt = Utils.covertZeroToNull(transInfo.payPlanAmt)
    state.transInfo.payDebtAmt = Utils.covertZeroToNull(transInfo.payDebtAmt)
    state.transInfo.payAmt = Utils.covertZeroToNull(transInfo.payAmt)
    state.transInfo.paymentId = transInfo.paymentId
    state.transInfo.invAmt = Utils.covertZeroToNull(transInfo.invAmt)
    state.transInfo.docMth = transInfo.docMth
    state.transInfo.docIndex = transInfo.docIndex
    state.transInfo.allowDuplicate = false
    state.transInfo.transRemarks = transInfo.transRemarks
    //
    state.transInfo.indUsed = transInfo.indUsed
  },
  updateEditIndex(state, value) {
    state.editIndex = value
  },
  updateJustUpdatedIndex(state, value) {
    state.justUpdatedIndex = value
  },
  updateEditAction(state, value) {
    state.editAction = value
  },
  updateEditDocMth(state, value) {
    state.editDocMth = value
  },
  updateEditDocIndex(state, value) {
    state.editDocIndex = value
  },
  updateEditAllowDuplicate(state, value) {
    state.editAllowDuplicate = value
  },
  // newEmptyRowObj() {
  //   return {
  //     ctrAcctId: '',
  //     type: '',
  //     indUsed: '',
  //     status: ''
  //   }
  // },
  appendBottomRow() {
    this.commit('projIncomeTransManage/updateProjIncomeTransEmpty')
    let obj = {...state.transInfo}
    // debugger
    obj.isBottomRow = true
    state.transList.push(obj)
  },
  handleAdd(state, {row, index}) {
    // debugger
    this.commit('projIncomeTransManage/updateProjIncomeTransEmpty')
    this.commit('projIncomeTransManage/updateEditIndex', index)
    this.commit('projIncomeTransManage/updateJustUpdatedIndex', -1)
    this.commit('projIncomeTransManage/updateEditAction', 'insert')
    //
    // this.commit('projIncomeTransManage/updateCtrAcctId', ctrAcctId)
    // this.commit('projIncomeTransManage/updateCostColId', costColId)
  },
  handleEdit(state, {row, index}) {
    // debugger
    this.commit('projIncomeTransManage/updateProjIncomeTransInfo', row)
    this.commit('projIncomeTransManage/updateEditIndex', index)
    this.commit('projIncomeTransManage/updateJustUpdatedIndex', -1)
    this.commit('projIncomeTransManage/updateEditAction', 'update')
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/projIncomeTransManage.js